import { footerInfo } from '@/mocks/siteData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-lg">51</span>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">51电影网</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed">
              {footerInfo.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {footerInfo.links.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-foreground-400 text-sm leading-relaxed">
              诚邀影视媒体、数据平台及行业机构合作共建。合作咨询请联系我们的商务团队。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">{footerInfo.copyright}</p>
          <p className="text-foreground-500 text-xs">影视吃瓜第一站 · 做清醒的吃瓜人</p>
        </div>
      </div>
    </footer>
  );
}